import request from './base';
import type { RequestOptionsInit } from 'umi-request';
import type { BaseRequest, CusRequest } from 'bv-request/lib/typings';
import { isValue } from 'bv-validator';
import { encrypt } from '@bluevision/tools';

const baseApi = '/api/ka_admin';

const publicKey = `-----BEGIN RSA PUBLIC KEY-----
MIIBCgKCAQEA0I7j9RrPP9tqoagcYv0UI7sWe5WBZqDrpl+Mk8mpBeVReLK9tqf6
zaHZqkp0kcPsmWqs2OAq+A18yZnuwje8xDrAp1ybUm4NdYdZxNzkQ/ovg4sEDWH3
gafzCRfmCyqdq54pqAx8aWcVsj3WtT00eMwhsjORavpl2SgaFVbtgePzt+SxuHzk
QYq0UgKLhQoyO6smh5AYTVuJYix2yz0ms+ENLwaYGBexCDs8N81y7u5xHlBcnFVj
fuhiavi0vWGPNx+t0WaJM4iHv3zdLD8m9rMvwATP/1jPKicA1YlGcJ0088zuiM08
fi9cYB+fZw9JaY+LVJmhojOMR/kBrRjdkQIDAQAB
-----END RSA PUBLIC KEY-----`;

const baseRequest: BaseRequest = (method, url, data, notice, id, addition) => {
  // 时间戳+随机数
  const clientFetchId = encrypt(Date.now() + Math.random().toString(16).slice(2), publicKey);

  return request(isValue(id) ? `${baseApi}/${url}/${id}` : `${baseApi}/${url}`, {
    method,
    data: method === 'GET' || method === 'DELETE' ? undefined : data,
    params: method === 'GET' || method === 'DELETE' ? data : undefined,
    notice,
    ...addition,
    headers: {
      'Client-Fetch-Id': !!clientFetchId ? clientFetchId : '',
    },
  } as RequestOptionsInit);
};

const read: CusRequest = (...r) => baseRequest('GET', ...r);

const post: CusRequest = (...r) => baseRequest('POST', ...r);

const put: CusRequest = (...r) => baseRequest('PUT', ...r);

const patch: CusRequest = (...r) => baseRequest('PATCH', ...r);

const del: CusRequest = (...r) => baseRequest('DELETE', ...r);

export { request, read, post, put, patch, del };
